import {
	ConditionalLinkConditions,
	Link,
	SharablePreset,
} from '@sharefiledev/sharing-pilet-sdk/api';
import { OptionCombination } from './linkInternalTypes';
import { getPermissionKeyFromContext } from './linkShare-utils';

export const findNextBestCombinationForOtherPlugin = (
	availableConditions: ConditionalLinkConditions[],
	availablePermissions: string[],
	conditionalLinks: Link[],
	sharablePresets: SharablePreset[]
): OptionCombination => {
	const availableOptionsSet = new Set<string>();
	const existingOptionsSet = new Set<string>();

	conditionalLinks.forEach(link => {
		const presentCondition = link.conditionalLinkOptions
			?.condition as ConditionalLinkConditions;
		existingOptionsSet.add(
			`${presentCondition}-${getPermissionKeyFromContext(
				link.conditionalLinkOptions?.presetRID,
				sharablePresets
			)}`
		);
	});

	availableConditions.forEach(availableCondition => {
		availablePermissions.forEach(availablePermission => {
			availableOptionsSet.add(`${availableCondition}-${availablePermission}`);
		});
	});

	for (const optionKey of availableOptionsSet) {
		if (!existingOptionsSet.has(optionKey)) {
			const [nextCondition, nextPermission] = optionKey.split('-');
			return {
				condition: nextCondition as ConditionalLinkConditions,
				permission: nextPermission,
			};
		}
	}
	const [firstExistingOption] = existingOptionsSet;
	const [condition, permission] = firstExistingOption.split('-');
	return {
		condition: condition as ConditionalLinkConditions,
		permission,
	};
};
